var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBtnRecall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "#005993",
    rx: 16
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M21.66 10.343A7.937 7.937 0 0 0 16.006 8a7.946 7.946 0 0 0-5.204 1.928l-1.55-1.523-.31 5.266 5.353-.396-1.52-1.407a5.213 5.213 0 0 1 3.231-1.115A5.25 5.25 0 0 1 21.25 16a5.25 5.25 0 0 1-5.242 5.247 5.221 5.221 0 0 1-3.565-1.4 5.23 5.23 0 0 1-1.66-3.427l-.034-.432H8l.03.497A8.002 8.002 0 0 0 16.007 24a7.938 7.938 0 0 0 5.652-2.343A7.952 7.952 0 0 0 24 16a7.952 7.952 0 0 0-2.34-5.657z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnRecall);
export default __webpack_public_path__ + "static/media/btn_Recall.29387e2de1a2abeb44f0fe2533f1fa4d.svg";
export { ForwardRef as ReactComponent };